define.alias("ember-power-select/components/power-select-multiple/trigger", "settings/components/power-select-multiple/trigger");